// extracted by mini-css-extract-plugin
export var childrenContainer = "_c0-0";
export var virtualScrollArea = "_c0-1";